import { Flex, Spinner } from '@chakra-ui/react'
import { useEffect, useState, useRef } from 'react'
import { FaPlayCircle } from 'react-icons/fa'
import { VscRefresh } from 'react-icons/vsc'
import { FormatarMensagemEditorDeTexto } from '../../Utils/Helper'
import { ContentVideo, PlayerContent, VideoScreen } from './styles'
import { useVideoBlob } from './useVideoBlob'

interface iVideoProps {
  url: string
  descricao?: string
  titulo?: string
  tituloPersonalizado?: React.ReactNode
  descricaoPersonalizada?: React.ReactNode
  preload?: boolean
}

export const VideoPlayer: React.FC<iVideoProps> = ({ url, descricao, titulo, tituloPersonalizado, descricaoPersonalizada, preload }) => {
  const [started, setStarted] = useState(false)
  const [ended, setEnded] = useState(false)
  const [querTocar, setQuerTocar] = useState(false)
  const $videoPlayer = useRef<HTMLVideoElement>(null)
  const { src, progresso } = useVideoBlob(url, preload === true || querTocar)
  const showOverlay = !started || ended
  const carregando = querTocar && !src

  useEffect(() => {
    if (src && querTocar) tocar()
  }, [src])

  function tocar(): void {
    $videoPlayer.current?.play().catch(() => {})
  }

  function play(): void {
    setQuerTocar(true)
    tocar()
  }

  return (
        <Flex flexDir={'column'}>
            <ContentVideo >
                <VideoScreen
                    active={showOverlay}
                    controls={started && !ended}
                    onPlay={() => { setStarted(true); setEnded(false) }}
                    onEnded={() => setEnded(true)}
                    onClick={showOverlay ? play : undefined}
                    ref={$videoPlayer} src={src}
                    style={{ maxHeight: '25rem', marginLeft: '1.2rem' }}
                />
                <PlayerContent display={showOverlay ? 'flex' : 'none'}>
                    <>
                        {
                            carregando
                              ? (
                                    <Flex flexDir={'column'} justifyContent={'center'} alignItems={'center'} gap={'.5rem'} marginBottom={'.5rem'}>
                                      <Spinner size={'lg'} />
                                      <small>Carregando vídeo{progresso !== null ? `... ${progresso}%` : '...'}</small>
                                    </Flex>
                                )
                              : ended
                                ? <VscRefresh size={50} onClick={play} />
                                : (
                                    <Flex flexDir={'column'}justifyContent={'center'} alignItems={'center'}>
                                      <FaPlayCircle cursor={'pointer'} style={{ marginBottom: '.5rem' }} size={50} onClick={play} />
                                    </Flex>
                                  )
                        }
                    </>
                    {tituloPersonalizado}
                    {descricaoPersonalizada}

                    {!tituloPersonalizado && titulo && <h2>{titulo}</h2>}
                    {!descricaoPersonalizada && descricao && <span dangerouslySetInnerHTML={{ __html: FormatarMensagemEditorDeTexto(descricao ?? '') }}></span>}
                </PlayerContent>
            </ContentVideo>
        </Flex>
  )
}
